import React from 'react';
import { CTableHeaderCell } from '@coreui/react';

export default function SortableHeader({ col, label, sortBy, sortDir, onSort }) {
  const active = sortBy === col;
  const arrow = active ? (sortDir === 'asc' ? ' ▲' : ' ▼') : ' ⇅';
  return (
    <CTableHeaderCell
      onClick={() => onSort(col)}
      style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
    >
      {label}<span style={{ opacity: active ? 1 : 0.35, fontSize: 11 }}>{arrow}</span>
    </CTableHeaderCell>
  );
}
